import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'graphql/SlackAuthCallback';

export const SLACK_AUTH = defineApiActionTypes(`${prefix}/SLACK_AUTH`);
